import { assessmentTemplate as ad8, assessmentScoring as ad8Scoring } from "./ad8";
import {
  assessmentTemplate as ar1001Prescreen,
  assessmentScoring as ar1001PrescreenScoring,
} from "./ar1001Prescreen";
import {
  assessmentTemplate as botpressCUAccount,
  assessmentScoring as botpressCUAccountScoring,
} from "./botpressCUAccount";
import {
  assessmentTemplate as botpressCUAlertsSettings,
  assessmentScoring as botpressCUAlertsSettingsScoring,
} from "./botpressCUAlertsSettings";
import {
  assessmentTemplate as botpressCUCards,
  assessmentScoring as botpressCUCardsScoring,
} from "./botpressCUCards";
import {
  assessmentTemplate as botpressCUDeposits,
  assessmentScoring as botpressCUDepositsScoring,
} from "./botpressCUDeposits";
import {
  assessmentTemplate as botpressCUStandard,
  assessmentScoring as botpressCUStandardScoring,
} from "./botpressCUStandard";
import {
  assessmentTemplate as botpressCUTransfersPayments,
  assessmentScoring as botpressCUTransfersPaymentsScoring,
} from "./botpressCUTransfersPayments";
import {
  assessmentTemplate as botpressDefault,
  assessmentScoring as botpressDefaultScoring,
} from "./botpressDefault";
import {
  assessmentTemplate as botpressFBBall,
  assessmentScoring as botpressFBBallScoring,
} from "./botpressFBBall";
import {
  assessmentTemplate as botpressFBFoulsMisconduct,
  assessmentScoring as botpressFBFoulsMisconductScoring,
} from "./botpressFBFoulsMisconduct";
import {
  assessmentTemplate as botpressFBMatchStructure,
  assessmentScoring as botpressFBMatchStructureScoring,
} from "./botpressFBMatchStructure";
import {
  assessmentTemplate as botpressFBOffsides,
  assessmentScoring as botpressFBOffsidesScoring,
} from "./botpressFBOffsides";
import {
  assessmentTemplate as botpressFBPlayerTeams,
  assessmentScoring as botpressFBPlayerTeamsScoring,
} from "./botpressFBPlayerTeams";
import {
  assessmentTemplate as botpressFBRestartsSetPieces,
  assessmentScoring as botpressFBRestartsSetPiecesScoring,
} from "./botpressFBRestartsSetPieces";
import {
  assessmentTemplate as careFirstWeight,
  assessmentScoring as careFirstWeightScoring,
} from "./careFirstWeight";
import {
  assessmentTemplate as clinicalDementiaRating,
  assessmentScoring as clinicalDementiaRatingScoring,
} from "./clinicalDementiaRating";
import {
  assessmentTemplate as dementiaSeverityRatingScale,
  assessmentScoring as dementiaSeverityRatingScaleScoring,
} from "./dementiaSeverityRatingScale";
import {
  assessmentTemplate as eos5Pillars,
  assessmentScoring as eos5PillarsScoring,
} from "./eos5Pillars";
import {
  assessmentTemplate as eosBusinessInformation,
  assessmentScoring as eosBusinessInformationScoring,
} from "./eosBusinessInformation";
import {
  assessmentTemplate as eosOnboarding,
  assessmentScoring as eosOnboardingScoring,
} from "./eosOnboarding";
import {
  assessmentTemplate as epworthSleepinessScale,
  assessmentScoring as epworthSleepinessScaleScoring,
} from "./epworthSleepinessScale";
import { assessmentTemplate as gad7, assessmentScoring as gad7Scoring } from "./gad7";
import {
  assessmentTemplate as hyperOnboard,
  assessmentScoring as hyperOnboardScoring,
} from "./hyperOnboard";
import {
  assessmentTemplate as independentFunction,
  assessmentScoring as independentFunctionScoring,
} from "./independentFunction";
import { assessmentTemplate as msqol, assessmentScoring as msqolScoring } from "./msqol";
import {
  assessmentTemplate as omniHealthHistory,
  assessmentScoring as omniHealthHistoryScoring,
} from "./omniHealthHistory";
import {
  assessmentTemplate as omniHealthHistoryDemo,
  assessmentScoring as omniHealthHistoryDemoScoring,
} from "./omniHealthHistoryDemo";
import {
  assessmentTemplate as omniMedicationReminderDemo,
  assessmentScoring as omniMedicationReminderDemoScoring,
} from "./omniMedicationReminderDemo";
import {
  assessmentTemplate as omniMSOnboard,
  assessmentScoring as omniMSOnboardScoring,
} from "./omniMSOnboard";
import {
  assessmentTemplate as pcrHairLoss,
  assessmentScoring as pcrHairLossScoring,
} from "./pcrHairLoss";
import { assessmentTemplate as phq8, assessmentScoring as phq8Scoring } from "./phq8";
import { assessmentTemplate as phq9, assessmentScoring as phq9Scoring } from "./phq9";
import {
  assessmentTemplate as singleLegStance,
  assessmentScoring as singleLegStanceScoring,
} from "./singleLegStance";

// import {
//   assessmentTemplate as uiControlTest,
//   assessmentScoring as uiControlTestScoring,
// } from "./uiControlTest";

export const assessmentTemplates = [].concat(
  ar1001Prescreen,
  independentFunction,
  ad8,
  careFirstWeight,
  clinicalDementiaRating,
  dementiaSeverityRatingScale,
  epworthSleepinessScale,
  gad7,
  msqol,
  omniHealthHistory,
  phq8,
  phq9,
  singleLegStance,
  pcrHairLoss,
  eosBusinessInformation,
  eos5Pillars,
  eosOnboarding,
  omniHealthHistoryDemo,
  omniMSOnboard,
  omniMedicationReminderDemo,
  hyperOnboard,
  botpressCUStandard,
  botpressDefault,
  botpressCUAccount,
  botpressCUAlertsSettings,
  botpressCUCards,
  botpressCUDeposits,
  botpressCUTransfersPayments,
  botpressFBBall,
  botpressFBFoulsMisconduct,
  botpressFBMatchStructure,
  botpressFBOffsides,
  botpressFBPlayerTeams,
  botpressFBRestartsSetPieces,
  // uiControlTest
);

export const assessmentScoring = [].concat(
  ar1001PrescreenScoring,
  independentFunctionScoring,
  ad8Scoring,
  careFirstWeightScoring,
  clinicalDementiaRatingScoring,
  dementiaSeverityRatingScaleScoring,
  epworthSleepinessScaleScoring,
  gad7Scoring,
  msqolScoring,
  omniHealthHistoryScoring,
  phq8Scoring,
  phq9Scoring,
  singleLegStanceScoring,
  pcrHairLossScoring,
  eosBusinessInformationScoring,
  eos5PillarsScoring,
  eosOnboardingScoring,
  omniHealthHistoryDemoScoring,
  omniMSOnboardScoring,
  omniMedicationReminderDemoScoring,
  hyperOnboardScoring,
  botpressCUStandardScoring,
  botpressDefaultScoring,
  botpressCUAccountScoring,
  botpressCUAlertsSettingsScoring,
  botpressCUCardsScoring,
  botpressCUDepositsScoring,
  botpressCUTransfersPaymentsScoring,

  botpressFBBallScoring,
  botpressFBFoulsMisconductScoring,
  botpressFBMatchStructureScoring,
  botpressFBOffsidesScoring,
  botpressFBPlayerTeamsScoring,
  botpressFBRestartsSetPiecesScoring,
  // uiControlTestScoring
);
